import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ShortcutModal = 'record-visit' | 'tracking-link' | 'upload-data' | null
export type ViewMode = 'desktop' | 'tablet' | 'mobile'

interface UIState {
  sidebarCollapsed: boolean
  sidebarSubmenus: Record<string, boolean>
  toggleSidebar: () => void
  setSidebarCollapsed: (v: boolean) => void
  toggleSidebarSubmenu: (key: string) => void
  setSidebarSubmenu: (key: string, open: boolean) => void

  /** Mobile drawer state — sidebar shown as overlay */
  mobileSidebarOpen: boolean
  setMobileSidebarOpen: (v: boolean) => void

  openModal: ShortcutModal
  setOpenModal: (m: ShortcutModal) => void

  /** Dev tool: simulate a smaller viewport. Removed in prod build. */
  viewMode: ViewMode
  setViewMode: (v: ViewMode) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      sidebarSubmenus: {
        'customer-journey': true,
        'qr-tracking': true,
        'plan-create': true,
        'source-data': true,
        'analytics-tracking': true,
        workspace: true,
        settings: true,
      },
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      toggleSidebarSubmenu: (key) =>
        set((s) => ({
          sidebarSubmenus: {
            ...s.sidebarSubmenus,
            [key]: !s.sidebarSubmenus[key],
          },
        })),
      setSidebarSubmenu: (key, open) =>
        set((s) => ({
          sidebarSubmenus: {
            ...s.sidebarSubmenus,
            [key]: open,
          },
        })),

      mobileSidebarOpen: false,
      setMobileSidebarOpen: (mobileSidebarOpen) => set({ mobileSidebarOpen }),

      openModal: null,
      setOpenModal: (openModal) => set({ openModal }),

      viewMode: 'desktop',
      setViewMode: (viewMode) => set({ viewMode }),
    }),
    {
      name: 'agent8-cdp:ui',
      partialize: (s) => ({
        sidebarCollapsed: s.sidebarCollapsed,
        sidebarSubmenus: s.sidebarSubmenus,
        viewMode: s.viewMode,
      }),
    },
  ),
)
